"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMetricsRbac = exports.useActiveRbacRole = void 0;
var react_1 = require("react");
var ai_hub_rbac_api_service_1 = require("../../shared/services/ai-hub-rbac-api.service");
var ELEMENT_SCOPE_PREFIX = 'elements.';
var stripElementScopePrefix = function (scope) {
    return scope.startsWith(ELEMENT_SCOPE_PREFIX) ? scope.slice(ELEMENT_SCOPE_PREFIX.length) : scope;
};
var toElementScope = function (scope) {
    return scope.startsWith(ELEMENT_SCOPE_PREFIX) ? scope : "" + ELEMENT_SCOPE_PREFIX + scope;
};
var hasScope = function (scopes, targetScope) {
    var normalizedTargetScope = stripElementScopePrefix(targetScope);
    return scopes.some(function (scope) { return stripElementScopePrefix(scope) === normalizedTargetScope; });
};
var getGroupOwnerSelectionKey = function (elementType, categoryId) {
    return elementType + ":" + categoryId;
};
var getPropertyOwnerPermission = function (elementType, propertyId) {
    if (propertyId.startsWith(ELEMENT_SCOPE_PREFIX)) {
        return propertyId;
    }
    if (propertyId.startsWith(elementType + ".")) {
        return toElementScope(propertyId);
    }
    return toElementScope(elementType + "." + propertyId);
};
exports.useActiveRbacRole = function () {
    var _a;
    var _b = react_1.useState(null), currentUser = _b[0], setCurrentUser = _b[1];
    react_1.useEffect(function () {
        var cancelled = false;
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ai_hub_rbac_api_service_1.fetchCurrentUser()];
                    case 1:
                        user = _a.sent();
                        if (!cancelled) {
                            setCurrentUser(user);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        void run();
        return function () {
            cancelled = true;
        };
    }, []);
    return ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) === null || _a === void 0 ? void 0 : _a.name) || 'regular-user';
};
exports.useMetricsRbac = function (elementType, selectedCategoryId, elementTypeOptions) {
    var _a;
    var _b = react_1.useState({}), groupOwnerSelectionsByCategoryId = _b[0], setGroupOwnerSelectionsByCategoryId = _b[1];
    var _c = react_1.useState({}), propertyOwnerSelectionsByPropertyId = _c[0], setPropertyOwnerSelectionsByPropertyId = _c[1];
    var _d = react_1.useState([]), groupOwners = _d[0], setGroupOwners = _d[1];
    var _e = react_1.useState([]), owners = _e[0], setOwners = _e[1];
    var _f = react_1.useState(null), currentUser = _f[0], setCurrentUser = _f[1];
    var activeRole = ((_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.role) === null || _a === void 0 ? void 0 : _a.name) || 'regular-user';
    var activePermissions = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.permissions) || [];
    var allowedElementTypeKeys = react_1.useMemo(function () {
        if (activeRole === 'admin') {
            return new Set(elementTypeOptions.map(function (option) { return option.key; }));
        }
        var keys = new Set();
        activePermissions.forEach(function (scope) {
            var normalizedScope = stripElementScopePrefix(scope);
            var categoryKey = normalizedScope.split('.')[0];
            if (!elementTypeOptions.some(function (option) { return option.key === categoryKey; })) {
                return;
            }
            if (normalizedScope === categoryKey + ".*" || normalizedScope.startsWith(categoryKey + ".")) {
                keys.add(categoryKey);
            }
        });
        return keys;
    }, [activePermissions, activeRole, elementTypeOptions]);
    react_1.useEffect(function () {
        var cancelled = false;
        var run = function () { return __awaiter(void 0, void 0, void 0, function () {
            var user, users, ownerUsers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ai_hub_rbac_api_service_1.fetchCurrentUser()];
                    case 1:
                        user = _a.sent();
                        if (!cancelled) {
                            setCurrentUser(user);
                        }
                        return [4 /*yield*/, ai_hub_rbac_api_service_1.fetchUsersByRole([3, 'group-owner'])];
                    case 2:
                        users = _a.sent();
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        setGroupOwners(users);
                        return [4 /*yield*/, ai_hub_rbac_api_service_1.fetchUsersByRole(['owner'])];
                    case 3:
                        ownerUsers = _a.sent();
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        setOwners(ownerUsers);
                        return [2 /*return*/];
                }
            });
        }); };
        void run();
        return function () {
            cancelled = true;
        };
    }, []);
    var groupOwnerOptions = react_1.useMemo(function () {
        return groupOwners.map(function (user) { return ({
            key: user.id,
            text: user.displayName,
        }); });
    }, [groupOwners]);
    var selectedGroupOwnerIds = react_1.useMemo(function () {
        if (!selectedCategoryId) {
            return [];
        }
        var selectionKey = getGroupOwnerSelectionKey(elementType, selectedCategoryId);
        var selectedByUser = groupOwnerSelectionsByCategoryId[selectionKey];
        if (selectedByUser) {
            return selectedByUser;
        }
        var ownerPermission = toElementScope(elementType + ".*");
        return groupOwners
            .filter(function (user) { return hasScope(user.permissions, ownerPermission); })
            .map(function (user) { return user.id; });
    }, [elementType, groupOwnerSelectionsByCategoryId, groupOwners, selectedCategoryId]);
    var ownerOptions = react_1.useMemo(function () {
        return owners.map(function (user) { return ({
            key: user.id,
            text: user.displayName,
        }); });
    }, [owners]);
    var getSelectedOwnerIdsForProperty = react_1.useCallback(function (propertyId) {
        var selectedByUser = propertyOwnerSelectionsByPropertyId[propertyId];
        if (selectedByUser) {
            return selectedByUser;
        }
        var permission = getPropertyOwnerPermission(elementType, propertyId);
        return owners.filter(function (user) { return hasScope(user.permissions, permission); }).map(function (user) { return user.id; });
    }, [elementType, owners, propertyOwnerSelectionsByPropertyId]);
    var updateGroupOwnerSelection = react_1.useCallback(function (ownerId, selected) { return __awaiter(void 0, void 0, void 0, function () {
        var permission, error_1, selectionKey;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedCategoryId) {
                        return [2 /*return*/];
                    }
                    permission = toElementScope(elementType + ".*");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!selected) return [3 /*break*/, 3];
                    return [4 /*yield*/, ai_hub_rbac_api_service_1.addUserScope(ownerId, permission)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, ai_hub_rbac_api_service_1.removeUserScope(ownerId, permission)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_1 = _a.sent();
                    console.warn('[rbac] failed to update owner scope', ownerId, permission, error_1.message);
                    return [2 /*return*/];
                case 7:
                    setGroupOwners(function (current) {
                        return current.map(function (user) {
                            if (user.id !== ownerId) {
                                return user;
                            }
                            var nextPermissions = selected
                                ? hasScope(user.permissions, permission)
                                    ? user.permissions
                                    : user.permissions.concat(permission)
                                : user.permissions.filter(function (existingPermission) {
                                    return stripElementScopePrefix(existingPermission) !==
                                        stripElementScopePrefix(permission);
                                });
                            return __assign(__assign({}, user), { permissions: nextPermissions });
                        });
                    });
                    selectionKey = getGroupOwnerSelectionKey(elementType, selectedCategoryId);
                    setGroupOwnerSelectionsByCategoryId(function (current) {
                        var _a;
                        var currentSelected = current[selectionKey] || selectedGroupOwnerIds;
                        var nextSelected = selected
                            ? currentSelected.includes(ownerId)
                                ? currentSelected
                                : currentSelected.concat(ownerId)
                            : currentSelected.filter(function (existingId) { return existingId !== ownerId; });
                        return __assign(__assign({}, current), (_a = {}, _a[selectionKey] = nextSelected, _a));
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [elementType, selectedCategoryId, selectedGroupOwnerIds]);
    var syncGroupOwnerSelection = react_1.useCallback(function (nextOwnerIds) { return __awaiter(void 0, void 0, void 0, function () {
        var permission, normalizedNextIds, currentIds, idsToAdd, idsToRemove, selectionKey;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedCategoryId) {
                        return [2 /*return*/];
                    }
                    permission = toElementScope(elementType + ".*");
                    normalizedNextIds = Array.from(new Set(nextOwnerIds));
                    currentIds = groupOwners
                        .filter(function (user) { return hasScope(user.permissions, permission); })
                        .map(function (user) { return user.id; });
                    idsToAdd = normalizedNextIds.filter(function (id) { return !currentIds.includes(id); });
                    idsToRemove = currentIds.filter(function (id) { return !normalizedNextIds.includes(id); });
                    return [4 /*yield*/, Promise.all(__spreadArrays(idsToAdd.map(function (ownerId) { return __awaiter(void 0, void 0, void 0, function () {
                            var error_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, ai_hub_rbac_api_service_1.addUserScope(ownerId, permission)];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_2 = _a.sent();
                                        console.warn('[rbac] failed to add owner scope', ownerId, permission, error_2.message);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }), idsToRemove.map(function (ownerId) { return __awaiter(void 0, void 0, void 0, function () {
                            var error_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, ai_hub_rbac_api_service_1.removeUserScope(ownerId, permission)];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_3 = _a.sent();
                                        console.warn('[rbac] failed to remove owner scope', ownerId, permission, error_3.message);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); })))];
                case 1:
                    _a.sent();
                    setGroupOwners(function (current) {
                        return current.map(function (user) {
                            var shouldHavePermission = normalizedNextIds.includes(user.id);
                            var hasPermission = hasScope(user.permissions, permission);
                            if (shouldHavePermission === hasPermission) {
                                return user;
                            }
                            var nextPermissions = shouldHavePermission
                                ? user.permissions.concat(permission)
                                : user.permissions.filter(function (existingPermission) {
                                    return stripElementScopePrefix(existingPermission) !==
                                        stripElementScopePrefix(permission);
                                });
                            return __assign(__assign({}, user), { permissions: nextPermissions });
                        });
                    });
                    selectionKey = getGroupOwnerSelectionKey(elementType, selectedCategoryId);
                    setGroupOwnerSelectionsByCategoryId(function (current) {
                        var _a;
                        return (__assign(__assign({}, current), (_a = {}, _a[selectionKey] = normalizedNextIds, _a)));
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [elementType, groupOwners, selectedCategoryId]);
    var updatePropertyOwnerSelection = react_1.useCallback(function (ownerId, propertyId, selected) { return __awaiter(void 0, void 0, void 0, function () {
        var permission, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!propertyId) {
                        return [2 /*return*/];
                    }
                    permission = getPropertyOwnerPermission(elementType, propertyId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!selected) return [3 /*break*/, 3];
                    return [4 /*yield*/, ai_hub_rbac_api_service_1.addUserScope(ownerId, permission)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, ai_hub_rbac_api_service_1.removeUserScope(ownerId, permission)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_4 = _a.sent();
                    console.warn('[rbac] failed to update property owner scope', ownerId, permission, error_4.message);
                    return [2 /*return*/];
                case 7:
                    setOwners(function (current) {
                        return current.map(function (user) {
                            if (user.id !== ownerId) {
                                return user;
                            }
                            var nextPermissions = selected
                                ? hasScope(user.permissions, permission)
                                    ? user.permissions
                                    : user.permissions.concat(permission)
                                : user.permissions.filter(function (existingPermission) {
                                    return stripElementScopePrefix(existingPermission) !==
                                        stripElementScopePrefix(permission);
                                });
                            return __assign(__assign({}, user), { permissions: nextPermissions });
                        });
                    });
                    setPropertyOwnerSelectionsByPropertyId(function (current) {
                        var _a;
                        var currentSelected = current[propertyId] || getSelectedOwnerIdsForProperty(propertyId);
                        var nextSelected = selected
                            ? currentSelected.includes(ownerId)
                                ? currentSelected
                                : currentSelected.concat(ownerId)
                            : currentSelected.filter(function (existingId) { return existingId !== ownerId; });
                        return __assign(__assign({}, current), (_a = {}, _a[propertyId] = nextSelected, _a));
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [elementType, getSelectedOwnerIdsForProperty]);
    var syncPropertyOwnerSelection = react_1.useCallback(function (propertyId, nextOwnerIds) { return __awaiter(void 0, void 0, void 0, function () {
        var permission, normalizedNextIds, currentIds, idsToAdd, idsToRemove;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!propertyId) {
                        return [2 /*return*/];
                    }
                    permission = getPropertyOwnerPermission(elementType, propertyId);
                    normalizedNextIds = Array.from(new Set(nextOwnerIds));
                    currentIds = owners
                        .filter(function (user) { return hasScope(user.permissions, permission); })
                        .map(function (user) { return user.id; });
                    idsToAdd = normalizedNextIds.filter(function (id) { return !currentIds.includes(id); });
                    idsToRemove = currentIds.filter(function (id) { return !normalizedNextIds.includes(id); });
                    return [4 /*yield*/, Promise.all(__spreadArrays(idsToAdd.map(function (ownerId) { return __awaiter(void 0, void 0, void 0, function () {
                            var error_5;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, ai_hub_rbac_api_service_1.addUserScope(ownerId, permission)];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_5 = _a.sent();
                                        console.warn('[rbac] failed to add property owner scope', ownerId, permission, error_5.message);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); }), idsToRemove.map(function (ownerId) { return __awaiter(void 0, void 0, void 0, function () {
                            var error_6;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, ai_hub_rbac_api_service_1.removeUserScope(ownerId, permission)];
                                    case 1:
                                        _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        error_6 = _a.sent();
                                        console.warn('[rbac] failed to remove property owner scope', ownerId, permission, error_6.message);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); })))];
                case 1:
                    _a.sent();
                    setOwners(function (current) {
                        return current.map(function (user) {
                            var shouldHavePermission = normalizedNextIds.includes(user.id);
                            var hasPermission = hasScope(user.permissions, permission);
                            if (shouldHavePermission === hasPermission) {
                                return user;
                            }
                            var nextPermissions = shouldHavePermission
                                ? user.permissions.concat(permission)
                                : user.permissions.filter(function (existingPermission) {
                                    return stripElementScopePrefix(existingPermission) !==
                                        stripElementScopePrefix(permission);
                                });
                            return __assign(__assign({}, user), { permissions: nextPermissions });
                        });
                    });
                    setPropertyOwnerSelectionsByPropertyId(function (current) {
                        var _a;
                        return (__assign(__assign({}, current), (_a = {}, _a[propertyId] = normalizedNextIds, _a)));
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [elementType, owners]);
    var canEditGroupOwners = activeRole === 'admin';
    var canEditPropertyOwners = activeRole === 'admin' || activeRole === 'group-owner';
    return {
        activeRole: activeRole,
        activePermissions: activePermissions,
        allowedElementTypeKeys: allowedElementTypeKeys,
        groupOwnerOptions: groupOwnerOptions,
        selectedGroupOwnerIds: selectedGroupOwnerIds,
        ownerOptions: ownerOptions,
        canEditGroupOwners: canEditGroupOwners,
        canEditPropertyOwners: canEditPropertyOwners,
        getSelectedOwnerIdsForProperty: getSelectedOwnerIdsForProperty,
        syncPropertyOwnerSelection: syncPropertyOwnerSelection,
        syncGroupOwnerSelection: syncGroupOwnerSelection,
        updateGroupOwnerSelection: updateGroupOwnerSelection,
        updatePropertyOwnerSelection: updatePropertyOwnerSelection,
    };
};
